import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '@openedx/paragon';
import { ViewOrderDetailsHyperlinkProps } from './types';

export const ViewOrderDetailsHyperlink = ({
  orderNumber,
}: ViewOrderDetailsHyperlinkProps) => (
  <Hyperlink
    destination={`${
      process.env.NEXT_PUBLIC_EDX_COMMERCE_COORDINATOR_BASE_URL! +
      process.env.NEXT_PUBLIC_EDX_CC_ORDER_RECEIPT_PATH!
    }?order_number=${orderNumber}`}
    target="_blank"
  >
    <FormattedMessage
      id="payment.order.history.cell.view.orders.details"
      defaultMessage="View Order Details"
      description="Link to an order receipt"
    />
  </Hyperlink>
);
